
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/merchant-payment-and-refunds",
      function () {
        return require("private-next-pages/merchant-payment-and-refunds/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/merchant-payment-and-refunds"])
      });
    }
  